import React, { useCallback } from "react";
import { reelTransferCRUD } from "../services/storageLocationService";

const useReelTransferCRUD=(callMessage)=>{

    const processIndent = useCallback(async ( requestBody) => {
            try {
          
    
                const successMessage = 'Reel Transfered Successfully';
    
                // Await the API response
                const data = await reelTransferCRUD( requestBody);
                
                if (data?.length > 0) {
                    callMessage('info', successMessage, 'info');
                } else {
                    callMessage('error', 'No data received from API', 'Error');
                }
            } catch (error) {
                callMessage('error', error.message || 'An unexpected error occurred', 'Error');
            }
        }, [callMessage]);

     return { processIndent };
};
export default useReelTransferCRUD;